import { Component, computed, inject, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { DocumentItemPartial } from 'src/app/domain/entities/partials/documents/document-item.partial';
import { RaCheckboxComponent } from 'src/app/shared/components/ra-checkbox/ra-checkbox.component';
import { RaIconComponent } from 'src/app/shared/components/ra-icon/ra-icon.component';
import { RaTooltipDirective } from 'src/app/shared/directives';
import { EditDataService } from '../../../services/_edit-data.service';
import { EditService } from '../../../services/edit-service';

/**
 * Card de uma PASTA de checklist (CHECKLIST_FOLDER) na lista de itens da seção:
 * checkbox de conclusão (só responsável/criador/owner), ícone, nome, contagem de
 * campos e seta. Clicar no card entra na pasta; o checkbox marca/desmarca.
 */
@Component({
    selector: 'folder-card',
    templateUrl: 'folder-card.component.html',
    styleUrl: 'folder-card.component.scss',
    imports: [FormsModule, TranslatePipe, RaCheckboxComponent, RaIconComponent, RaTooltipDirective],
})
export class FolderCardComponent {
    public field = input.required<DocumentItemPartial>();
    public open = output<DocumentItemPartial>();

    public editDataService = inject(EditDataService);
    public editService = inject(EditService);

    public isDone = computed(() => this.field().checklist?.done ?? false);
    public canComplete = this.editDataService.canCompleteChecklist;
    public childCount = computed(
        () =>
            (this.editDataService.currentSession()?.items ?? []).filter(
                item => item.parentFolderId === this.field()._id
            ).length
    );

    public onToggleDone(done: boolean): void {
        const sessionId = this.editDataService.getCurrentSessionId();
        if (!sessionId) return;
        this.editService.markFolderCompleted(sessionId, this.field()._id, done);
    }
}
